import {ATTENDANCE_STATUS} from '../../../CodeMaster'
import {Nullable} from '../../../app/TypeHelpers'
import {Moment} from 'moment'
import BaseMeetingAttendanceResponse from './BaseMeetingAttendanceResponse'


export default class MeetingAttendanceResponse extends BaseMeetingAttendanceResponse {
    attendanceId: number
    note: Nullable<string>
    proxyUserName: Nullable<string>
    proxyUserRelationship: Nullable<string>
    responseDateTime: Moment
    agentRespondentAdminId: Nullable<string>
    agentRespondentRoleName: string
    agentRespondentName: string
    version: number

    constructor(
        attendanceStatus: ATTENDANCE_STATUS,
        attendanceId: number,
        note: Nullable<string>,
        proxyUserName: Nullable<string>,
        proxyUserRelationship: Nullable<string>,
        responseDateTime: Moment,
        agentRespondentAdminId: Nullable<string>,
        agentRespondentRoleName: string,
        agentRespondentName: string,
        version: number,
    ) {
        super(attendanceStatus)
        this.attendanceId = attendanceId
        this.note = note
        this.proxyUserName = proxyUserName
        this.proxyUserRelationship = proxyUserRelationship
        this.responseDateTime = responseDateTime
        this.agentRespondentAdminId = agentRespondentAdminId
        this.agentRespondentRoleName = agentRespondentRoleName
        this.agentRespondentName = agentRespondentName
        this.version = version
    }
}
